import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Header from '../components/layout/Header';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Translate from './layout/Translate';
import * as userActions from '../actions/user';
import Helmet from "react-helmet";
import Facebook from './popups/Facebook';


// Be sure to include styles at some point, probably during your bootstrapping



class CustomTour extends Component {

  componentWillMount() {
    this.props.userActions.fetchCountry();

      this.messageParams = {
          destinations: [],
          date: {value: null, required: true, error: false, label: 'Ориентировочная дата начала путешествия'},
          length: {value: null, required: true, error: false, label: 'Продолжительность путешествия'},
          count: {value: 1, title: '1', required: true, error: false, label: 'Количество взрослых'},
          childrenCount: {value: 0, title: '0', error: false, label: 'Количество детей'},
          childrenAge: {value: null, requiredCondition: ['childrenCount'], error: false, label: 'Возраст детей'},
          firstName: {value: '', required: true, error: false, label: 'Имя'},
          lastName: {value: '', required: true, error: false, label: 'Фамилия'},
          email: {value: '', required: true, error: false, label: 'E-MAIL'},
          phone: {value: null, required: true, error: false, label: 'Телефон'},
          country: {value: null, required: true, error: false, label: 'Гражданство'},
          connectType: {value: 'email', title: 'Email', error: false, label: 'предпочитаемый способ связи'},
          description: {value: null, required: true, error: false, label: 'Описание'},
          condition: {value: false, required: true},
          privacy: {value: false, required: true}
      };

      let messageParams = this.messageParams;
      this.props.destinations.forEach(function(destination){
        messageParams.destinations.push(Object.assign({}, destination));
      });

  }



  componentDidUpdate () {
    let actions = this.props.actions;

    if (this.props.user.message && this.props.user.message.promise) {

      this.props.user.message.promise.json().then(function (result) {

        //console.info('result')
        //console.info(result)

        actions.setCustomTourResult(result);
      });
    }
  }

  changeMessage(field, e) {
    this.messageParams[field].value = e.target.value;
    this.messageParams[field].title = e.target.value;
    this.props.userActions.changeCustomTour(this.messageParams);
  }


  changeSelect(field, e) {
    this.messageParams[field].value = e.id;
    this.messageParams[field].title = e.title;
    this.props.userActions.changeCustomTour(this.messageParams);
  }

  changeDate(e) {
    this.messageParams.date.value = e;
    this.messageParams.date.title = e.utc().format('DD.MM.YYYY');

    this.props.userActions.changeCustomTour(this.messageParams);
  }

  changeDestination(destination, e) {

    destination.checked = !destination.checked;
    this.props.userActions.changeCustomTour(this.messageParams);
  }


  changeCheckbox(field, e) {

    this.messageParams[field].value = !this.messageParams[field].value;
    this.props.userActions.changeCustomTour(this.messageParams);
  }

  sendMessage() {
    let messageParams = this.messageParams;
    let hasErrors = false;
    let text = '';
    for (let key in this.messageParams) {
      let item = this.messageParams[key];
      if (item.required && !item.value) {
        item.error = true;
        hasErrors = true;
      } else {
        item.error = false;
      }
      if (item.requiredCondition && !item.value) {
        item.requiredCondition.forEach(function(condition){
          if (messageParams[condition].value) {
            item.error = true;
            hasErrors = true;
          } else {
            item.error = false;
          }
        });
      }

      if (item.label && (typeof item == 'object') && item.title) {
          text+= item.label + ': ' + item.title + '\n';
      } else if (Array.isArray(item)) {
        text+= 'Направления: ';

        item.forEach(function(destination){
          if (destination.checked) {
            text += destination.title + ', ';
          }
        });

        text += '\n';
      }

    }

    let data = {
      title: 'Заказ индивидуального тура ' + this.props.user.lang,
      email: messageParams.email.value,
      firstName: messageParams.firstName.value,
      lastName: messageParams.lastName.value,
      lang: this.props.user.lang,
      text: text
    };

    this.hasErrors = hasErrors;

    if (hasErrors || this.props.user.fetchMessage) {
      this.props.userActions.changeCustomTour(this.messageParams);
    } else {
      this.props.userActions.sendCustomTour(data);
    }

  }

  componentWillUpdate() {
  }


  componentDidUpdate () {
  }



  render () {
    const {destinations, user} = this.props;

    moment.locale(user.lang);
    const now = moment();
    const end = moment(now.valueOf() + (60*60*24*365*2*1000));
    const countList = [];
    const childrenCountList = [];

    for (let key = 1; key <= 30; key++) {
      countList.push({id: key, title: key});
    }
    for (let key = 0; key <= 30; key++) {
      childrenCountList.push({id: key, title: key});
    }

    return (
      <div>
        <Helmet
            title={user.translations['custom__title']}
        />
        <section className="section section__page main">

          <Header />
          <div className="container container_form">

            <div className="form__title">
              <Translate slug="custom__title" />
            </div>

              {(user.message && user.message.success) &&
                <div className="form__success">
                  <Translate slug="custom__success" />
                </div>
              }
            {!(user.message && user.message.success) &&
            <div>
              <div className="form__text">
                <Translate slug="custom__top-text" html={true} />
              </div>

              <div className="form__block">
                <h3 className="form__subtitle">
                  <Translate slug="custom__destinations" />
                </h3>
                <div className="form__row">

                  <div className="form__col form__col_12">
                    {this.messageParams.destinations.map((destination) =>
                        <label className="form__label form__label_inline form__label_checkbox" key={destination.slug}>
                          <input className="checkbox" type="checkbox" name={destination.slug}
                                 checked={destination.checked} onChange={this.changeDestination.bind(this, destination)}/>
                          <span>{destination.title}</span>
                        </label>
                    )}
                  </div>
                </div>
              </div>


              <div className="form__block">
                <h3 className="form__subtitle">
                  <Translate slug="custom__period" />
                </h3>

                <div className="form__row">
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__date" />
                    </label>
                    <label className="form__label_picker">
                      <DatePicker
                          selected={this.messageParams.date.value}
                          className={"form__control form__input form__input_datepicker" + (this.messageParams.date.error?' form__control_error':'')}
                          forceShowMonthNavigation={true}
                          showYearDropdown={true}
                          showMonthDropdown={true}
                          dropdownMode={'select'}
                          onChange={this.changeDate.bind(this)}
                          minDate={now}
                          maxDate={end}
                          readOnly={true}
                      />
                    </label>
                  </div>
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__length" />
                    </label>
                    <input type="text"
                           className={"form__control form__input" + (this.messageParams.length.error?' form__control_error':'')}
                           value={this.messageParams.length.value} onChange={this.changeMessage.bind(this, 'length')}/>
                  </div>
                </div>
              </div>


              <div className="form__block">
                <h3 className="form__subtitle">
                  <Translate slug="custom__count" />
                </h3>

                <div className="form__row">
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__count__adult" />
                    </label>
                    <Select
                        name="form__select"
                        value={this.messageParams.count.value}
                        options={countList}
                        clearable={false}
                        searchable={false}
                        onChange={this.changeSelect.bind(this, 'count')}
                        className={"form__select" + (this.messageParams.count.error?' form__control_error':'')}
                        labelKey="title"
                        valueKey="id"
                        autoBlur={true}
                    />
                  </div>
                  <div className="form__col form__col_3">
                    <label className="form__label">
                      <Translate slug="custom__count__children" />
                    </label>
                    <Select
                        name="form__select"
                        value={this.messageParams.childrenCount.value}
                        options={childrenCountList}
                        clearable={false}
                        searchable={false}
                        onChange={this.changeSelect.bind(this, 'childrenCount')}
                        className={"form__select" + (this.messageParams.childrenCount.error?' form__control_error':'')}
                        labelKey="title"
                        valueKey="id"
                        autoBlur={true}
                    />
                  </div>
                  {!!this.messageParams.childrenCount.value &&
                    <div className="form__col form__col_3">
                      <label className="form__label">
                        <Translate slug="custom__children-age"/>
                      </label>
                      <input type="text" disabled={!this.messageParams.childrenCount.value}
                             className={"form__control form__input" + (this.messageParams.childrenAge.error?' form__control_error':'')}
                             value={this.messageParams.childrenAge.value}
                             onChange={this.changeMessage.bind(this, 'childrenAge')}/>
                    </div>
                  }
                </div>
              </div>



              <div className="form__block">
                <h3 className="form__subtitle">
                  <Translate slug="custom__communications" />
                </h3>

                <div className="form__row">
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__first-name" />
                    </label>
                    <input type="text"
                           className={"form__control form__input" + (this.messageParams.firstName.error?' form__control_error':'')}
                           value={this.messageParams.firstName.value}
                           onChange={this.changeMessage.bind(this, 'firstName')}/>
                  </div>
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__email" />
                    </label>
                    <input type="text"
                           className={"form__control form__input" + (this.messageParams.email.error || (user.message && !user.message.success)?' form__control_error':'')}
                           value={this.messageParams.email.value} onChange={this.changeMessage.bind(this, 'email')}/>
                  </div>
                </div>

                <div className="form__row">
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__last-name" />
                    </label>
                    <input type="text"
                           className={"form__control form__input" + (this.messageParams.lastName.error?' form__control_error':'')}
                           value={this.messageParams.lastName.value}
                           onChange={this.changeMessage.bind(this, 'lastName')}/>
                  </div>
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__phone" />
                    </label>
                    <input type="text"
                           className={"form__control form__input" + (this.messageParams.phone.error?' form__control_error':'')}
                           value={this.messageParams.phone.value} onChange={this.changeMessage.bind(this, 'phone')}/>
                  </div>
                </div>

                <div className="form__row">
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__country" />
                    </label>
                    <Select
                        name="country"
                        options={(user.countryList?user.countryList:[])}
                        clearable={false}
                        searchable={true}
                        value={this.messageParams.country.value}
                        className={"form__select" + (this.messageParams.country.error?' form__control_error':'')}
                        onChange={this.changeSelect.bind(this, 'country')}
                        labelKey="title"
                        valueKey="id"
                        autoBlur={true}
                        placeholder=""
                    />
                  </div>
                  <div className="form__col form__col_6">
                    <label className="form__label">
                      <Translate slug="custom__connect-type" />
                    </label>
                    <Select
                        name="connect"
                        value={this.messageParams.connectType.value}
                        options={[{id: 'email', title: user.translations['custom__email']}, {id: 'phone', title: user.translations['custom__phone']}]}
                        clearable={false}
                        searchable={false}
                        onChange={this.changeSelect.bind(this, 'connectType')}
                        className={"form__select" + (this.messageParams.connectType.error?' form__control_error':'')}
                        labelKey="title"
                        valueKey="id"
                        autoBlur={true}
                    />
                  </div>
                </div>
              </div>


              <h3 className="form__subtitle">
                <Translate slug="custom__text__title" />
              </h3>
              <div className="form__text" style={{paddingTop: 18}}>

                <Translate slug="custom__text_bottom" />
              </div>
              <div className="form__row">

                <div className="form__col form__col_12">
                          <textarea
                              className={"form__control form__textarea form__control_auto" + (this.messageParams.description.error?' form__control_error':'')}
                              value={this.messageParams.description.value}
                              onChange={this.changeMessage.bind(this, 'description')}>

                          </textarea>
                </div>
              </div>

              <div className="form__row">

                <div className="form__col form__col_center form__col_12">
                  <label className="conditions"><input className="checkbox" type="checkbox"
                                             checked={this.messageParams.condition.value}
                                             onChange={this.changeCheckbox.bind(this, 'condition')}/>
                    <span><Translate slug="custom__accept" /> <a
                        href="/conditions-individual" target="_blank"> <Translate slug="custom__conditions" /></a></span></label>
                </div>
                <div className="form__col_center form__col_12">
                  <label className="conditions"><input className="checkbox" type="checkbox"
                                             checked={this.messageParams.privacy.value}
                                             onChange={this.changeCheckbox.bind(this, 'privacy')}/>
                    <span><Translate slug="custom__accept2" /> <a
                        href="/privacy" target="_blank"> <Translate slug="custom__privacy" /></a></span></label>
                </div>
              </div>
              {((user.message && !user.message.success) || this.hasErrors) &&
              <div className="form__error">
                <Translate slug="custom__error" />
              </div>
              }
              <div className="form__buttons">
                <input
                    className={"form__button form__button_success form__button_large" + (this.props.user.fetchMessage?' feedback__button_progress':'')}
                    type="button" value={user.translations['custom__send']} onClick={this.sendMessage.bind(this)}/>
              </div>


            </div>
            }
          </div>

          <div className="clearfix"></div>
          <Facebook page={true} blockClass={"facebook_form"} />
          <div className="footer__registration">
            <Translate
                slug="main__registration"/>
          </div>





        </section>


      </div>
    );
  }
}

CustomTour.need = [

];


function mapStateToProps(state) {
  //console.log(state);

  return {
    user: state.user,
    destinations: state.tours.destinations
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(userActions, dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CustomTour);


// WEBPACK FOOTER //
// ./src/common/components/CustomTour.js